import { DateTime } from 'luxon';
import { Option } from './utilityTypes';

interface ArchivableEntity {
    archivedAt: null | DateTime;
}

const getActionFromArchivedAt = (
    entity: Option<ArchivableEntity>
): 'archive' | 'unarchive' => {
    return !entity || entity?.archivedAt ? 'unarchive' : 'archive';
};

export { getActionFromArchivedAt };
export type { ArchivableEntity };
